import Node      from './src/node'
import Wrap      from './src/wrap'
import Animate   from './src/animate'
import Intersect from './src/intersect'

const Plugin = {
  install(Vue) {
    Vue.component(Node.name, Node)
    Vue.component(Wrap.name, Wrap)
    Vue.component(Animate.name, Animate)
    Vue.component(Intersect.name, Intersect)
  }
}

export default Plugin
